import sanitize from 'sanitize-html';

export type AllowedSymbol = '>' | '<' | '"' | '`' | "'";

export const strEscape = ({
    str,
    allowedSymbols = [],
}: {
    str?: string;
    allowedSymbols?: AllowedSymbol[];
}) => {
    if (typeof str !== 'string') {
        return '';
    }

    const allowedSet = new Set(allowedSymbols);

    let result = str;

    if (!allowedSet.has('>')) {
        result = result.replace(/>/g, '&gt;');
    }
    if (!allowedSet.has('<')) {
        result = result.replace(/</g, '&lt;');
    }
    if (!allowedSet.has('"')) {
        result = result.replace(/"/g, '&quot;');
    }
    if (!allowedSet.has('`')) {
        result = result.replace(/`/g, '&#x60;');
    }
    if (!allowedSet.has("'")) {
        result = result.replace(/'/g, '&apos;');
    }

    return result;
};

export const sanitizeText = ({
    text,
    allowedSymbols = [],
}: {
    text?: string;
    allowedSymbols?: AllowedSymbol[];
}) => (text ? strEscape({ str: sanitize(text), allowedSymbols }) : undefined);
